import { HTMLAttributes, PropsWithChildren } from 'react';
import cx from 'classnames';

interface SectionProps {
  id?: string;
  background?:
    | 'WHITE'
    | 'GRAY'
    | 'NEUTRAL_GRAY'
    | 'DARK_GRAY'
    | 'SLATE'
    | 'BLUE'
    | 'BRIGHT_BLUE';
  borderless?: boolean;
  className?: HTMLAttributes<HTMLDivElement>['className'];
}

export const Section: React.FC<PropsWithChildren<SectionProps>> = ({
  id,
  background = 'WHITE',
  borderless = false,
  children,
  className,
}) => {
  return (
    <section
      id={id}
      className={cx(
        'py-8 lg:py-12 space-y-6 scroll-mt-24',
        background === 'WHITE' && 'bg-white',
        background === 'GRAY' && 'bg-gray-200',
        background === 'NEUTRAL_GRAY' && 'bg-gray-300',
        background === 'DARK_GRAY' && 'bg-gray-900',
        background === 'SLATE' && 'bg-slate-100',
        background === 'BLUE' && 'bg-blue-50',
        background === 'BRIGHT_BLUE' && 'bg-blue-500',
        !borderless && 'border-t',
        className,
      )}
    >
      {children}
    </section>
  );
};

interface RowProps {
  inset?: boolean;
  className?: HTMLAttributes<HTMLDivElement>['className'];
}

export const Row: React.FC<PropsWithChildren<RowProps>> = ({
  inset = false,
  className,
  children,
}) => {
  return (
    <div
      className={cx(
        'container px-4 flex flex-wrap mx-auto md:space-x-8 space-y-8 md:space-y-0',
        inset && 'max-w-4xl',
        className,
      )}
    >
      {children}
    </div>
  );
};

interface ColumnProps {
  flexBasis?: string | number;
  flexGrow?: string | number;
  className?: HTMLAttributes<HTMLDivElement>['className'];
}

export const Column: React.FC<PropsWithChildren<ColumnProps>> = ({
  flexBasis,
  flexGrow,
  className,
  children,
}) => (
  <div
    className={cx('space-y-4 h-full md:p-2 min-w-full md:min-w-0', className)}
    style={{
      flexBasis:
        typeof flexBasis === 'string' || typeof flexBasis === 'number'
          ? flexBasis
          : 1,
      flexGrow:
        typeof flexBasis === 'string' || typeof flexGrow === 'number'
          ? flexGrow
          : 1,
    }}
  >
    {children}
  </div>
);
